
export default function TabEconomics() {
  return (

    <div>                                    
        <div>
            <iframe width="100%"
                    height="360"                 
                    src="https://www.youtube.com/embed/Tez-qmOjYvw"
                    title="The Wave Mill Short Presentation" 
                    frameborder="0"
                    allowfullscreen></iframe>
        </div>
        <div>  Short Presentation</div>
        <br />
        <div>
            <iframe width="100%"
                    height="360"   
                    src="https://www.youtube.com/embed/NCyZDSZ2hKs"
                    title="The Wave Mill Presentation" 
                    frameborder="0"
                    allowfullscreen></iframe>
        </div>
        <div>  Wave Mill Presentation</div>
            <br />
        <div>
            <iframe width="100%"
                    height="360"
                    src="https://www.youtube.com/embed/baB2UuD5I9c"
                    title="Windy weather" 
                    frameborder="0"
                    allowfullscreen></iframe>
        </div>
        <div>Windy weather</div>
            <br />
        <div>
            <iframe width="100%"
                    height="360"
                    src="https://www.youtube.com/embed/h0k0aHKJrcQ"
                    title="Inside air-duct part one" 
                    frameborder="0"
                    allowfullscreen></iframe>
        </div>
        <div>Inside air-duct part one</div>
            <br />
        <div>
            <iframe width="100%"
                    height="360"
                    src="https://www.youtube.com/embed/rBpzBKJmDmM"
                    title="Inside air-duct part two" 
                    frameborder="0"
                    allowfullscreen></iframe>
        </div>
        <div> Inside air-duct part two</div>               
    </div>   

  )
}
